import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { Injectable, Injector, inject } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OverlayFactory } from '@frontend/vanilla/shared/overlay-factory';

import { IErrorData } from './client-models/coordinator.models';
import { GDSTroubleshooterMessage } from './client-models/location-info';
import { ErrorDataToken, ErrorMessagesToken } from './constants';

@Injectable({ providedIn: 'root' })
export class GeoCoordinationOverlayService {
    private injector = inject(Injector);
    private overlay = inject(OverlayFactory);

    private currentRef: OverlayRef | null;

    show(
        componentToShow: ComponentType<any>,
        {
            cssClasses = [],
            errorData = undefined,
            errorMessages = undefined,
        }: {
            readonly cssClasses: string[];
            readonly errorData?: IErrorData;
            readonly errorMessages?: GDSTroubleshooterMessage[];
        },
    ) {
        if (this.currentRef) {
            return;
        }

        const overlayRef = this.overlay.create({
            panelClass: ['vn-host-geolocation-panel', 'generic-modal-popup', ...cssClasses],
        });

        overlayRef.detachments().subscribe(() => {
            this.overlay.dispose(overlayRef);
            this.currentRef = null;
        });

        const portal = new ComponentPortal(
            componentToShow,
            null,
            Injector.create({
                providers: [
                    { provide: OverlayRef, useValue: overlayRef },
                    { provide: ErrorDataToken, useValue: errorData },
                    { provide: ErrorMessagesToken, useValue: errorMessages },
                ],
                parent: this.injector,
            }),
        );

        overlayRef.attach(portal);
        this.currentRef = overlayRef;
    }
}
